<template>
  <div class="content-430 settlement-details-box">
    <!-- 显示内容 start  -->
    <section data-html2canvas-ignore>
      <SettlementDetailsTop
        :title-str="eduAreaName"
        :edu-area-code="eduAreaCode"
        :table-data="tableData"
        :approval-mode-id="ApprovalModeId"
        @getChangeBillPlatfromMode="getChangeBillPlatfromMode"
        @on-download="onDownload"
        @on-sdetails="onSdetailsTop"
        @on-search-finish="onSearchFinish"
      ></SettlementDetailsTop>
      <div
        v-if="tableType == 2 && (portOrg == 2 || portOrg == 0)"
        class="tab-block"
        :value="payeeType"
      >
        <Tabs type="card" @on-click="changeTab">
          <TabPane label="全部" name=""></TabPane>
          <TabPane label="校外课程" name="1"></TabPane>
          <TabPane label="校内课程" name="2"></TabPane>
        </Tabs>
      </div>

      <SettlementDetailsTable
        :key="$route.path"
        :bill-platfrom-mode="billPlatfromMode"
        :table-data="tableData"
        :loading="loading"
        :title-str="eduAreaName"
        :edu-area-code="eduAreaCode"
        :approval-mode-id="ApprovalModeId"
        @on-selectionTable="onSelectionTable"
      ></SettlementDetailsTable>
      <div v-if="tableType == 3 && type == 1" class="page-wrap">
        <Page
          :total="pageInfo.count"
          show-total
          :current="pageInfo.page"
          :page-size="pageInfo.size"
          show-elevator
          @on-change="handlePageChange"
          @on-page-size-change="handlePageSize"
        ></Page>
      </div>
      <template v-if="tableType != 3">
        <SettlementDetailsFooter
          :bill-platfrom-mode="billPlatfromMode"
          :bank-id="detailsData.bankId"
          :bank-data="bankData"
        ></SettlementDetailsFooter>
      </template>
      <!-- v-if="tableType == 3 && type != 1" -->
      <template v-if="showDetailsStep&& billPlatfromMode !== '3'">
        <SettlementDetailsStep
          :audit="audit"
          :table-data="tableData"
        ></SettlementDetailsStep>
      </template>
    </section>
    <!-- 显示内容 end  -->
    <!-- 打印内容 start  -->
    <div v-if="clickDownload" id="print-section" class="print-section">
      <section
        v-for="(item, index) in printData"
        :id="`settlement-download-details-${index}`"
        :key="index"
        class="settlement-download-details"
      >
        <SettlementDetailsTop
          :download="true"
          :table-data="tableData"
          :title-str="eduAreaName"
          :edu-area-code="eduAreaCode"
        ></SettlementDetailsTop>
        <div :class="['print-main', 'print-main-' + index]">
          <SettlementDetailsTable
            :key="$route.path"
            :bill-platfrom-mode="billPlatfromMode"
            :table-data="item"
            :index="index"
            :download="true"
            :approval-mode-id="ApprovalModeId"
          ></SettlementDetailsTable>
        </div>

        <template v-if="tableType != 3 && index == printData.length - 1">
          <SettlementDetailsFooter
            :bill-platfrom-mode="billPlatfromMode"
            :bank-id="detailsData.bankId"
            :bank-data="bankData"
            :download="true"
          ></SettlementDetailsFooter>
        </template>
      </section>
    </div>

    <!-- 打印内容 end  -->
  </div>
</template>

<script>
import SettlementDetailsTop from './assets/components/SettlementDetailsTop.vue';
import SettlementDetailsTable from './assets/components/SettlementDetailsTable.vue';
import SettlementDetailsFooter from './assets/components/SettlementDetailsFooter.vue';
import SettlementDetailsStep from './assets/components/SettlementDetailsStep.vue';
import orderCenterApi from '@/request/orderCenter/index.js';
import educationAdmin from '@/request/educationAdmin/index.js';
import { mapState, mapActions } from 'vuex';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import common from '@/request/common/index';
import { deepCopy } from '@/utils/utils.js';
import { handleEventTableData, handlePrintData, handlePrintData1, abs } from './assets/data/utils';
import { getSearchsStorage, setSearchsStorage } from '@/utils/storage';
// import { getPdf430 } from '@/utils/htmlToPdf.js';
import JsPDF from 'jspdf';

export default {
  components: {
    SettlementDetailsTop,
    SettlementDetailsTable,
    SettlementDetailsFooter,
    SettlementDetailsStep
  },
  provide() {
    return {
      detailsData: this.detailsData,
      tableType: this.tableType,
      type: this.type,
      selectionTableRows: () => this.selectionTableRows
    };
  },

  data() {
    return {
      searchData: {}, // 搜索数据
      pageInfo: {
        page: 1,
        count: 0,
        size: 100
      },
      clickDownload: false,
      payeeType: '', // 1=校外课程 2=校内课程
      detailsData: JSON.parse(decodeURIComponent(this.$route.query.detailsData)),
      type: this.$route.query.type, // 1 : 教育局-教育局账单
      tableType: this.$route.meta.tableType,
      tableData: [],
      printData: [],
      eduAreaName: '',
      eduAreaCode: '',
      bankData: {
        cardNo: '',
        openBankName: '',
        cardCustName: ''
      }, // 银行账户数据
      loading: false,
      eduSearchData: null,
      audit: [],
      portOrg: localStorage.getItem('portOrg'),
      selectionTableRows: [],
      ApprovalModeId: '',
      fakeData: [
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市宏途教育培训中心',
          'totalFee': '1719000',
          'orgFee': '1699664',
          'platServiceFee': '8352',
          'wxAmt': '10984',
          'noonCare': '1671000',
          'lateCare': '0',
          'fullCare': '0',
          'classroomFee': '48000',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市宏兔兔科技教育协会',
          'totalFee': '5212900',
          'orgFee': '5064198',
          'platServiceFee': '115630',
          'wxAmt': '33072',
          'noonCare': '4548500',
          'lateCare': '24400',
          'fullCare': '0',
          'classroomFee': '640000',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市宏兔兔教育培训中心',
          'totalFee': '44000',
          'orgFee': '36080',
          'platServiceFee': '7656',
          'wxAmt': '264',
          'noonCare': '0',
          'lateCare': '0',
          'fullCare': '0',
          'classroomFee': '44000',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市宏途黄埔跳绳协会',
          'totalFee': '2341500',
          'orgFee': '2326514',
          'platServiceFee': '0',
          'wxAmt': '14986',
          'noonCare': '2341500',
          'lateCare': '0',
          'fullCare': '0',
          'classroomFee': '0',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市黄埔区宏途教育培训中心',
          'totalFee': '456000',
          'orgFee': '373920',
          'platServiceFee': '79344',
          'wxAmt': '2736',
          'noonCare': '0',
          'lateCare': '0',
          'fullCare': '0',
          'classroomFee': '456000',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市黄埔区集泰培训中心有限公司',
          'totalFee': '10490400',
          'orgFee': '9734683',
          'platServiceFee': '692316',
          'wxAmt': '63401',
          'noonCare': '6520000',
          'lateCare': '1466400',
          'fullCare': '0',
          'classroomFee': '2504000',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市黄埔区广泰培训中心有限公司',
          'totalFee': '884500',
          'orgFee': '878839',
          'platServiceFee': '0',
          'wxAmt': '5661',
          'noonCare': '884500',
          'lateCare': '0',
          'fullCare': '0',
          'classroomFee': '0',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市集泰教育培训中心',
          'totalFee': '1582950',
          'orgFee': '1560265',
          'platServiceFee': '12810',
          'wxAmt': '9875',
          'noonCare': '1384750',
          'lateCare': '73200',
          'fullCare': '125000',
          'classroomFee': '0',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市光泰兴星体育俱乐部',
          'totalFee': '6986500',
          'orgFee': '6941793',
          'platServiceFee': '0',
          'wxAmt': '44707',
          'noonCare': '6986500',
          'lateCare': '0',
          'fullCare': '0',
          'classroomFee': '0',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市宏途羽毛球俱乐部',
          'totalFee': '24000',
          'orgFee': '19680',
          'platServiceFee': '4176',
          'wxAmt': '144',
          'noonCare': '0',
          'lateCare': '0',
          'fullCare': '0',
          'classroomFee': '24000',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市集泰青少年体育俱乐部',
          'totalFee': '80000',
          'orgFee': '65600',
          'platServiceFee': '13920',
          'wxAmt': '480',
          'noonCare': '0',
          'lateCare': '0',
          'fullCare': '0',
          'classroomFee': '80000',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市宏途体育俱乐部',
          'totalFee': '2923750',
          'orgFee': '2890479',
          'platServiceFee': '14616',
          'wxAmt': '18655',
          'noonCare': '2839750',
          'lateCare': '0',
          'fullCare': '0',
          'classroomFee': '84000',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-08-15 19:34:24',
          'bankType': 2,
          'bankId': '10002'
        },
        {
          'statementId': '863425219719614464',
          'orgId': '682281253591863296',
          'orgName': '广州广泰技术有限公司',
          'totalFee': '607500',
          'orgFee': '603612',
          'platServiceFee': '0',
          'wxAmt': '3888',
          'noonCare': '607500',
          'lateCare': '0',
          'fullCare': '0',
          'classroomFee': '0',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市集泰名人教育培训中心',
          'totalFee': '584000',
          'orgFee': '478880',
          'platServiceFee': '101616',
          'wxAmt': '3504',
          'noonCare': '0',
          'lateCare': '0',
          'fullCare': '0',
          'classroomFee': '584000',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州宏兔兔数字科技有限公司',
          'totalFee': '1284700',
          'orgFee': '1256826',
          'platServiceFee': '19746',
          'wxAmt': '8128',
          'noonCare': '1171500',
          'lateCare': '49200',
          'fullCare': '0',
          'classroomFee': '64000',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市宏途足球俱乐部',
          'totalFee': '14630650',
          'orgFee': '13982817',
          'platServiceFee': '555569',
          'wxAmt': '92264',
          'noonCare': '11438250',
          'lateCare': '92400',
          'fullCare': '0',
          'classroomFee': '3100000',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        },
        {
          'statementId': '898659786415964160',
          'orgId': '614870790701060096',
          'orgName': '广州市宏途数科教育培训中心',
          'totalFee': '180000',
          'orgFee': '147600',
          'platServiceFee': '31320',
          'wxAmt': '1080',
          'noonCare': '0',
          'lateCare': '0',
          'fullCare': '0',
          'classroomFee': '180000',
          'attachmentPrice': '0',
          'statementSts': 1,
          'settleSts': 1,
          'settleTime': '2023-10-17 13:15:39',
          'bankType': 1,
          'bankId': '10001'
        }
      ],
      billPlatfromMode: this.$route.meta.tableType == 1 && localStorage.getItem('portOrg') == 0 ? '3' : '1', // 对于机构结算单的 1：平台账单模式 2：收款单位账单模式
      beginTime: '', // 教务确认单的开始时间
      endTime: ''// 教务确认单的结束时间
    };
  },
  computed: {
    ...mapState({
      isTrueTally: state => state.orderCenter.isTrueTally,
      userInfo: state => state.userInfo
    }),
    showDetailsStep() {
      return (this.tableType == 3 && this.type != 1) || ([0, 2, 3].includes(this.portOrg) && this.tableType == 1);
    },
    // 是否是 2022年8月份以后
    isNinthMonth() {
      const day = this.detailsData.beginTime.split('-');
      const dayNum = String(day[0]) + String(day[1]);
      return Number(dayNum) > 202208;
    }

  },
  watch: {
    isTrueTally(newVal) {
      this.handleRequestTable();
    },
    billPlatfromMode(newVal) {
      console.log(newVal, '拿到的莫得mode');
      // this.clickDownload = false;
      newVal === '3' ? this.getAllOrgTallyDetailList() : this.getOrgTallyDetailByAdmin();
      // this.$nextTick(() => {
      //   this.clickDownload = true;
      // });
    }
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    console.log('执行了开始阶段11111111', this.detailsData, this.tableType, '拿到的0000000000');
    this.udpateNodeEnum(0);
    if (this.portOrg == 1) {
      this.getEduAreaName(this.userInfo.orgId);
      this.getProcessConfiguration(this.userInfo.orgId);
    }

    if (this.detailsData.tableType != 1) {
      this.handleRequestTable();
    }
  },
  methods: {
    ...mapActions('orderCenter', [
      'getProcessConfiguration', 'udpateNodeEnum', 'updateSettlementDetailsSearch', 'udpateAudit'
    ]),
    // 分页
    handlePageChange(v) {
      this.pageInfo.page = v;
      this.getEduAllyDetail();
    },
    // 跳转第几页
    handlePageSize(pageSize) {
      this.pageInfo.size = pageSize;
      this.pageInfo.page === 1 && this.getEduAllyDetail();
    },
    getChangeBillPlatfromMode(mode) {
      console.log(mode, '拿到的新的-----');
      this.billPlatfromMode = mode;
    },
    changeTab(name) {
      this.payeeType = name;
      this.handleRequestTable();
    },
    handleRequestTable() {
      console.log('去请求表格数据---');
      this.getUserOrderTallyDetail(this.detailsData);
      if (this.showDetailsStep) {
        this.getAuditDetail();
      }
    },
    onSelectionTable(rows) {
      console.log(rows, 'rowsrows');
      this.selectionTableRows = rows;
    },
    // 查询审批明细
    async getAuditDetail() {
      const res = await orderCenterApi.getQueryAndApproveSplitBills({
        sheetId: this.detailsData.sheetId
      });
      if (res.status == 200) {
        this.audit = res.message;
        this.udpateAudit(res.message);
      }
    },
    // 顶部
    onSdetailsTop(top) {
      this.detailsData.data.eduId = top.eduId;
      this.detailsData.data.eduName = top.eduName;
      this.handleRequestTable();
    },
    // 顶部搜索
    onSearchFinish(val) {
      console.log(val, '顶部搜索---');
      this.searchData = val;
      this.getEduAllyDetail(val);
    },
    // 根据机构信息查询银行卡信息
    async getFindBankCardInfo({ acctPlatType, orgId }) {
      console.log('查询银行卡信息0000');
      const res = await orderCenterApi.getFindBankCardInfo({ acctPlatType, orgId });
      if (res.data.status == 200 && res.data.message) {
        this.bankData = res.data.message;
      }
    },
    // 获取教育局下的区域名称
    async getEduAreaName(eduId) {
      return new Promise(async(resolve, reject) => {
        const res = await educationAdmin.getEduAreaName({ eduId });
        if (res.status == 200) {
          this.eduAreaName = res.message.areaName;
          this.eduAreaCode = res.message.areaCode;
          common.getConfigureSettlementApprovalProcess({
            areaCode: this.eduAreaCode
          }).then(res => {
            if (res.status == 200) {
              this.ApprovalModeId = res.message;
            }
            resolve();
          });
        }
      });
    },
    //
    async getUserOrderTallyDetail(val) {
      if ([0, 2, 3].includes(val.portOrg) && val.tableType == 1) {
        console.log('拿到的tab选中的', this.detailsData, this.billPlatfromMode);
        this.billPlatfromMode === '3' ? this.getAllOrgTallyDetailList() : this.getOrgTallyDetailByAdmin(val);

        this.getEduAreaName(val.data.eduId);
        return null;
      }
      if ([0, 2].includes(val.portOrg) && val.tableType == 2) {
        this.getSchTallyDetailBySch(val);
        this.getEduAreaName(val.data.schId);
        return null;
      }
      if ([1].includes(val.portOrg) && val.tableType == 2) {
        this.getEduOrgAllyDetail(val);
      }
    },
    // 平台账单模式 获取所有的服务学校
    async getAllOrgTallyDetailList() {
      console.log(this.detailsData);
      this.loading = true;
      const { bankId, orgId, settleMonth, termCode, yearCode } = this.detailsData;
      const params = {
        orgId, settleMonth,
        termCode, yearCode
      };
      const res = await orderCenterApi.getSubSheetListApi(params);
      this.getFindBankCardInfo({ orgId, acctPlatType: bankId });
      this.loading = false;
      console.log(res, '拿到的数据--123456789--');
      if (res.status === 200) {
        const otherOrgNameMap = [];
        res.message.forEach(item => {
          if (item.sheetId === this.detailsData.sheetId) {
            item.tag = 1;
          }
          item.totalFee = item.settleAvailAmt;
          item.noonCare = item.noonCareAmt;
          item.lateCare = item.lateCareAmt;
          item.fullCare = item.fullCareAmt;
          item.platServiceFee = item.platTotalAmt;
          item.totalDivideAmt = item.merchantAmt;
          if (item.otherSubLedgerParties && item.otherSubLedgerParties.length > 0) {
            item.otherSubLedgerParties.forEach((item_1, index_1) => {
              item['otherOrgName' + (item_1.orgId)] = item_1.totalDivideAmt;
              if (!otherOrgNameMap.includes('otherOrgName' + (item_1.orgId))) {
                otherOrgNameMap.push('otherOrgName' + (item_1.orgId));
              }
            });
          }
        });
        handleEventTableData(res.message, ['noonCare', 'lateCare', 'fullCare', 'attachmentPrice', 'classroomFee', 'totalFee', 'platServiceFee', 'totalDivideAmt', 'totalChannelAmt', ...otherOrgNameMap]);
        this.tableData = res.message;
        console.log(this.tableData, '拿到的数据---');
        const printData = deepCopy(this.tableData);
        this.printData = printData.length > 0 ? handlePrintData1(printData, 14, this.tableType) : [];
      }
    },
    // 机构类列表数据
    async getOrgTallyDetailByAdmin(val) {
      this.tableData = [];
      this.loading = true;
      const { sheetId, orgId, bankId: acctPlatType } = this.detailsData;
      // const { orgId } = this.detailsData.data;

      const res = await orderCenterApi.getSubOrgSheetDetailsList({ sheetId });
      this.getFindBankCardInfo({ orgId, acctPlatType });
      this.loading = false;
      if (res.status == 200 && res.message.length) {
        const otherOrgNameMap = [];
        res.message.forEach(item => {
          if (item.otherSubLedgerParties && item.otherSubLedgerParties.length > 0) {
            item.otherSubLedgerParties.forEach((item_1, index_1) => {
              item['otherOrgName' + (item_1.orgId)] = item_1.totalDivideAmt;
              if (!otherOrgNameMap.includes('otherOrgName' + (item_1.orgId))) {
                otherOrgNameMap.push('otherOrgName' + (item_1.orgId));
              }
            });
          }
        });
        handleEventTableData(res.message, ['noonCare', 'lateCare', 'fullCare', 'attachmentPrice', 'classroomFee', 'totalFee', 'platServiceFee', 'totalDivideAmt', 'totalChannelAmt', ...otherOrgNameMap]);
        this.tableData = res.message;
        const printData = deepCopy(this.tableData);
        this.printData = printData.length > 0 ? handlePrintData1(printData, 14, this.tableType) : [];
      }
    },
    // 学校类列表数据
    async getSchTallyDetailBySch(val) {
      const { bankId, schoolId, settleMonth, yearCode, termCode } = this.detailsData;
      this.loading = true;
      const params = {
        bankId,
        schoolId,
        settleMonth,
        yearCode, termCode
      };
      // this.payeeType ? params.payeeType = this.payeeType : '';
      const res = await orderCenterApi.getSchSubSheetList(params);
      this.loading = false;
      if (res.status == 200 && res.message.length) {
        let beginTime = '';
        let endTime = '';
        res.message.forEach(item => {
          if (beginTime && item.beginTime) {
            new Date(item.beginTime).getTime() < new Date(beginTime).getTime() ? beginTime = item.beginTime : '';
          } else {
            beginTime = item.beginTime;
          }
          if (endTime && item.endTime) {
            new Date(item.endTime).getTime() > new Date(endTime).getTime() ? endTime = item.endTime : '';
          } else {
            endTime = item.endTime;
          }
        });
        this.beginTime ? '' : this.beginTime = beginTime;
        this.endTime ? '' : this.endTime = endTime;
        // this.detailsData = { ...this.detailsData, beginTime: this.beginTime, endTime: this.endTime };
        this.detailsData.beginTime = this.beginTime;
        this.detailsData.endTime = this.endTime;
        const list = res.message.filter(item => {
          return this.payeeType && this.payeeType === '1' ? item.offerOrgId !== this.detailsData.schoolId : this.payeeType && this.payeeType === '2' ? item.offerOrgId === this.detailsData.schoolId : item;
        });
        handleEventTableData(list, ['noonCareAmt', 'lateCareAmt', 'fullCareAmt', 'attachmentPrice', 'classroomFee', 'totalDivideAmt', 'settleAvailAmt', 'platAmt']);

        // 学校端 教务是否可操作确认单
        if (this.portOrg == 2) {
          this.setTableSelectionStatus(list);
        }
        this.tableData = list;
        console.log(this.tableData, '拿到的数据-------432424');
        const printData = deepCopy(this.tableData);
        this.printData = printData.length > 0 ? handlePrintData1(printData, 14, this.tableType) : [];
      } else if (res.status == 200) {
        this.tableData = [];
        const printData = deepCopy(this.tableData);
        this.printData = printData.length > 0 ? handlePrintData1(printData, 14, this.tableType) : [];
      }
    },
    // 处理是否 教务能操作确认确认单数据
    setTableSelectionStatus(list) {
      list.forEach(item => {
        if (item.approvalSts != 0 && this.portOrg != 2) {
          item._disabled = true;
        } else {
          item._disabled = false;
        }
        if (item.orgName == '合计') {
          item._disabled = true;
        }
      });
    },
    // 查询机构结算账单详情-教育局端
    async getEduOrgAllyDetail(data) {
      this.loading = true;
      const res = await orderCenterApi.getEduOrgAllyDetail(data);
    },

    // 教育局列表数据
    async getEduAllyDetail() {
      const data = this.searchData;
      this.loading = true;
      this.tableData = [];
      this.detailsData.data.orgId = data.orgId;
      this.detailsData.data.orgName = data.orgName;
      this.detailsData.data.bankId = data.acctPlatType;
      delete data.orgName;
      this.eduSearchData = data;
      let res;
      // data.yearCode = this.detailsData.yearCode;
      // data.termCode = this.detailsData.termCode;
      if (!this.eduAreaCode) {
        await this.getEduAreaName(this.detailsData.data.eduId);
      }

      // if (this.portOrg == 0) {
      //   res = await orderCenterApi.getEduTallyOrderDetailByAdmin(data);
      // } else {
      //   res = await orderCenterApi.getEduTallyOrderDetail(data);
      // }
      res = await orderCenterApi.getSubSheetListPage({
        bankId: data.bankId,
        areaCode: this.eduAreaCode,
        settleMonth: this.detailsData.settleMonth,
        isShowZero: data.isShowZero,
        approvalSts: data.approvalSts,
        settlementSheetOrgId: data.settlementSheetOrgId,
        orgId: data.orgId,
        settleSts: data.settleSts,
        pageNum: this.pageInfo.page,
        pageSize: this.pageInfo.size,
        termCode: this.detailsData.termCode,
        yearCode: this.detailsData.yearCode
      });

      this.loading = false;

      if (res.status == 200 && res.message.list.length) {
        res.message.list.forEach(item => {
          item.orgCheck = item.approvalSts;
          item.unionCheck = item.approvalSts;
          item.eduCheck = item.approvalSts;
          item.payeeCheck = item.approvalSts;
          // item.orgId = item.offerOrgId
          // item.offerOrgName = item.offerOrgName
        });
        const otherOrgNameMap = [];
        res.message.list.forEach(item => {
          if (item.otherSubLedgerParties && item.otherSubLedgerParties.length > 0) {
            item.otherSubLedgerParties.forEach((item_1, index_1) => {
              item['otherOrgName' + (item_1.orgId)] = item_1.totalDivideAmt;
              if (!otherOrgNameMap.includes('otherOrgName' + (item_1.orgId))) {
                otherOrgNameMap.push('otherOrgName' + (item_1.orgId));
              }
            });
          }
        });
        handleEventTableData(res.message.list, ['availBal', 'settleAvailAmt', 'endAvailBal', 'commission', 'merchantPoundage', 'platformPoundage', 'platAmt', 'platTotalAmt', 'realPlatAmt', 'merchantAmt', 'noonCareAmt', 'lateCareAmt', 'fullCareAmt', 'attachmentPrice', 'classroomFee', ...otherOrgNameMap], '当前页面小计', (+this.pageInfo.size) * (+this.pageInfo.page - 1));
        this.handleTableTotal(res.message.list, ['orgCheck', 'unionCheck', 'eduCheck', 'payeeCheck']);
        this.tableData = res.message.list;
        this.pageInfo.count = +res.message.total;
        console.log('this.tableData', this.tableData);
      }
    },
    // 处理合计
    handleTableTotal(arr, targets = []) {
      for (const k in arr[arr.length - 1]) {
        if (targets.includes(k)) {
          arr[arr.length - 1][k] = '';
        }
      }
    },
    // 下载处理
    async onDownload(data) {
      if (data.type == 1) {
        if (this.tableType == 2 || this.tableType == 1) {
          this.clickDownload = true;
          this.$nextTick(() => {
            setTimeout(async() => {
              try {
                const { fileName, fileId } = await this.getPdf('print-section', data.titleStr, this);
                this.submitSettlementSheetDownRec(data, fileName, fileId);
              } finally {
                this.clickDownload = false;
              }
            }, 100);
          });
        }
      } else if (data.type == 2) {
        this.exportByTallyOrderDetail();
      }
    },
    // 下载埋点
    async submitSettlementSheetDownRec(data, fileName, fileId) {
      // 学校确认单
      const { tableType, schId: schoolId, beginTime, bankId, orgId } = data;
      if (tableType == 2) {
        await orderCenterApi.schoolSettlementSheetDownRec({
          schoolId,
          fileName,
          fileId,
          beginTime,
          bankId
          // statementId: this.detailsData.statementId
        });
      }
      if (tableType == 1) {
        await orderCenterApi.orgSettlementSheetDownRec({
          orgId,
          fileName,
          fileId,
          beginTime,
          bankId,
          statementId: this.detailsData.sheetId,
          modeTypeDes: this.billPlatfromMode === '3' ? '【服务学校模式】' : this.billPlatfromMode === '1' ? '【单服务学校模式】' : ''
        });
      }
    },
    // 下载审批单详情
    async exportByTallyOrderDetail() {
      if (!this.tableData.length) {
        return this.$Message.warning('暂无数据导出');
      }
      const params = Object.assign({}, this.eduSearchData);
      params.areaCode = this.eduAreaCode;
      this.$Spin.show();
      const single = getSearchsStorage('settlementActionShow');
      const res = await orderCenterApi.exportEduSubSheet({
        areaCode: params.areaCode,
        isShowAllAccountsOrg: single ? 1 : 0,
        eduId: params.eduId,
        isShowZero: params.isShowZero,
        settleMonth: params.beginTime,
        termCode: this.detailsData.termCode,
        yearCode: this.detailsData.yearCode,
        bankId: params.bankId,
        orgId: params.orgId,
        settlementSheetOrgId: params.settlementSheetOrgId,
        approvalSts: params.approvalSts,
        settleSts: params.settleSts
      });
      // if (this.portOrg == 0) {
      //   res = await orderCenterApi.exportByTallyOrderDetailByadmin(params);
      // } else {
      //   res = await orderCenterApi.exportByTallyOrderDetail(params);
      // }

      this.$Spin.hide();
      if (res.data.type === 'application/vnd.ms-excel') {
        this.$Message.success('导出成功');
        downLoadByBlob(res);
      } else {
        this.$Message.error('导出失败');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.settlement-details-box {
  position: relative;
}
.print-section {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: -9999;
  padding: 30px;
}
.settlement-download-details {
  /* position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: -9999;
  padding: 30px; */
  .print-main {
  }
}
.tab-block {
  padding-left: 30px;
}
.page-wrap{
  margin-top: -50px;
}
</style>
